import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";

export default function BookDownloadButton({ url, title, fullWidth }) {
  const { t } = useTranslation("arena");
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const pathname = new URL(url).pathname;
      const lastSegment = pathname.split("/").pop() ?? "";
      const dotIndex = lastSegment.lastIndexOf(".");
      const ext = dotIndex > 0 ? lastSegment.slice(dotIndex + 1) : "";
      const safeTitle = title.replace(/[/\\:*?"<>|]/g, "_");
      const filename = ext ? `${safeTitle}.${ext}` : safeTitle;

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(
          `Download failed: ${response.status} ${response.statusText}`
        );
      }
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(blobUrl);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth={fullWidth}
      disabled={downloading}
      onClick={handleDownload}
      startIcon={<DownloadIcon />}
    >
      {t("book.download")}
    </Button>
  );
}

BookDownloadButton.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};
